// utils/prospectUtils.js

import { isdealConfirmedAndHasNewAddition } from "./fieldAccess";

export const shouldDisableActionButton = () => {
  const currProspectStr = sessionStorage.getItem("currProspect");

  if (currProspectStr) {
    const currProspect = JSON.parse(currProspectStr);
    return isdealConfirmedAndHasNewAddition(currProspect);
  }

  return false;
};
